import React from 'react';

const Button = ({ 
    children, 
    variant = 'primary', 
    className = '', 
    ...props 
}) => {
    const baseStyles = 'px-4 py-2 rounded-lg transition-colors';
    
    const variants = {
        primary: 'bg-blue-600 hover:bg-blue-700 text-white',
        secondary: 'bg-[#252526] text-[#CCCCCC] hover:bg-[#3E3E42] border border-[#3E3E42]',
        danger: 'text-red-500 hover:text-red-600 border border-[#3E3E42]',
        cancel: 'bg-[#252526] text-[#CCCCCC] hover:bg-[#3E3E42] border border-[#3E3E42]',
        edit: 'text-blue-600 hover:text-blue-700 px-3 py-1 border border-[#3E3E42]',
        pagination: 'px-3 py-1 border rounded disabled:opacity-50 border-[#3E3E42] hover:bg-[#3E3E42]',
        tab: 'bg-[#252526] text-[#CCCCCC] hover:bg-[#3E3E42]',
        'tab-active': 'bg-[#3E3E42] text-white',
		ghost: 'bg-[#252526] px-2 py-3 opacity-100 text-white hover:opacity-70'
    };

    return (
        <button
            className={`${baseStyles} ${variants[variant]} ${className}`}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button; 